import Vue from "vue";
import router from "./../../router";
import { i18n } from "./../../main";

export async function fetchDocuments({ commit }, userLogin) {
  try {
    commit("setLoading", true, { root: true });
    let res = await fetch(Vue.prototype.$apiRoute + "docs/" + userLogin, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    });

    let resJson = await res.json();
    return {
      estado: res.ok,
      respuesta: resJson
    };
  } catch (error) {
    Vue.prototype.$toast(i18n.t('mensajes.inicioSesion'), {
      color: "blue"
    });
    commit("Auth/logout", null, { root: true });
    router.push("login");
  } finally {
    commit("setLoading", false, { root: true });
  }
}
